/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The payment method type that represents a payment rail and directionality
 */
export const PaymentMethodType = {
  MoovWallet: "moov-wallet",
  AchDebitFund: "ach-debit-fund",
  AchDebitCollect: "ach-debit-collect",
  AchCreditStandard: "ach-credit-standard",
  AchCreditSameDay: "ach-credit-same-day",
  RtpCredit: "rtp-credit",
  CardPayment: "card-payment",
  PushToCard: "push-to-card",
  PullFromCard: "pull-from-card",
  ApplePay: "apple-pay",
  CardPresentPayment: "card-present-payment",
} as const;
/**
 * The payment method type that represents a payment rail and directionality
 */
export type PaymentMethodType = ClosedEnum<typeof PaymentMethodType>;

/** @internal */
export const PaymentMethodType$inboundSchema: z.ZodNativeEnum<
  typeof PaymentMethodType
> = z.nativeEnum(PaymentMethodType);
/** @internal */
export const PaymentMethodType$outboundSchema: z.ZodNativeEnum<
  typeof PaymentMethodType
> = PaymentMethodType$inboundSchema;
